module.exports = __webpack_public_path__ + "media/theme/step--4-495d2f34.png";